export function lookupForm() {

    $("#fvmplookup").on('click', function(event) {
        event.preventDefault();
        var identifier = $.trim($("#isinlookup").val());
        if (identifier.length == 9 || identifier.length == 12) {
            if (identifier == '') {
                $("#resultmessage").html('Please enter your bond’s CUSIP or ISIN.');
                $(".search_result").show();
                $(".resultstable").hide();
                $("#resultmessage").show();
            } else {
                $.ajax({
                    //url: "https://beta.trumid.com/api/labs/fvmp/v1.0/bond/" + identifier,
                    //url: "api/labs/fvmp/v1.0/bond/" + identifier,
                    type: 'post',
                    url: '/wp-admin/admin-ajax.php',
                    data: {
                        action: 'bond_check',
                        data: identifier,
                    },
                    success: function(result) {
                        if (result.status == 'ok') {
                            var parsed_data         = result,
                                data_description    = parsed_data.description,
                                data_level          = Math.round(parsed_data.spread * 10)/10,
                                data_bid            = Math.round(parsed_data.spreadBid * 10)/10,
                                data_offer          = Math.round(parsed_data.spreadOffer * 10)/10,
                                data_confidence     = Math.round(parsed_data.confidenceScore*1000)/10,
                                symbol              = '+';

                            if(data_confidence == 0)
                                data_confidence = '0.0';

                            if(parsed_data.pricingConvention == 'price'){
                                data_level  = Math.round(parsed_data.price * 1000)/1000;
                                data_bid    = Math.round(parsed_data.priceBid * 1000)/1000;
                                data_offer  = Math.round(parsed_data.priceOffer * 1000)/1000;
                                symbol              = '$';
                            }

                            if (data_level == null) {
                                data_level = '';
                            } else if (data_level > 0) {
                                data_level = symbol + data_level;
                            }

                            if (data_bid == null) {
                                data_bid = '';
                            } else if (data_bid > 0) {
                                data_bid = symbol + data_bid;
                            }


                            if (data_offer == null) {
                                data_offer = '';
                            } else if (data_offer > 0) {
                                data_offer = symbol + data_offer;
                            }


                            var date = new Date(parsed_data.lastUpdatedAt);
                            var NewHour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                            var NewMinute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                            var NewSecond = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                            var data_lastUpdatedAt = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + NewHour + ':' + NewMinute + ':' + NewSecond;
                            $("#row-description").html(data_description);
                            $("#row-level").html(data_level);
                            $("#row-bid").html(data_bid);
                            $("#row-offer").html(data_offer);
                            $("#row-confidence").html(data_confidence + '%');
                            $("#rowUpdate").html(data_lastUpdatedAt);
                            $(".search_result").show();
                            $("#resultmessage").hide();
                            $(".resultstable").show();
                        } else {
                            $("#resultmessage").html('There is no information.');
                            $(".search_result").show();
                            $(".resultstable").hide();
                            $("#resultmessage").show();
                        }

                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        if (xhr.status == 404) {
                            $("#resultmessage").html('Bond requested is not covered by FVMP service');
                        } else if (xhr.status == 202) {
                            $("#resultmessage").html('FVMP service loading, please try again shortly');
                        } else if (xhr.status > 404) {
                            if (xhr.status == 429) {
                                $("#resultmessage").html(' <strong>Too Many Requests</strong><br/><br/>Thanks for your interest in FVMP.<br/><br/>For more information, please contact <a href="mailto:info@trumid.com">info@trumid.com</a>').css("margin", "0 auto !important");
                            } else {
                                $("#resultmessage").html('FVMP service temporarily unavailable, please try again shortly');
                            }
                        } else {
                            $("#resultmessage").html('Bond identifier is invalid, please try again');
                        }
                        $(".search_result").show();
                        $(".resultstable").hide();
                        $("#resultmessage").show();
                    }
                });
            }
        } else {

            $("#resultmessage").html('Bond identifier is invalid, please try again');
            $(".search_result").show();
            $(".resultstable").hide();
            $("#resultmessage").show();
        }
    });

    $(".refreshbond").on("click", function() {
        $("#fvmplookup").trigger("click");
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/lookup-form.js